import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import AuthRouting from './AuthRouting'
import AdminRouting from './AdminRouting'
import AutoLogin from '../screens/auto-login'
import { useSelector } from 'react-redux'

export default function Routing() {
  const { token }  = useSelector(state => state.auth);
  const location   = useLocation();

  if (location.pathname === '/auto-login') {
    return (
      <Routes>
        <Route path="/auto-login" element={<AutoLogin />} />
      </Routes>
    );
  }

  return !token ? <AuthRouting /> : <AdminRouting />;
}
